import * as yup from 'yup';

export interface TaskDataProps {
  title: string;
}

export const schema = yup.object().shape({
  title: yup.string().trim().nullable(),
});
